import React from 'react'

const DynamicStyles: React.FC = () => {
  return <style>{
    `
      @media screen and (min-width: 1024px){
        footer .container {
            max-width: unset !important;
        }
      }
      @media screen and (min-width: 1408px) {
        footer .container {
          max-width: 1440px !important;
        }
      }

      @media screen and (min-width: 850px) {
        .footerContent {
          footer {
            padding: 10000px !important
          }
        }
      }

    `}
  </style>
}

export default DynamicStyles
